
export default {
  state: {
    shopPrices: [],
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    shopPrices: state => state.shopPrices,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setShopPrices(state, shopPrices) {
      state.shopPrices = shopPrices;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {

    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {

        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const shopPrices = await axios.get('api/shop-prices' + (query || ''));
        commit('setShopPrices', shopPrices);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/shop-prices/' + id);
      } catch (e) {
      }
    },

    async update({ commit }, prices) {
      await axios.put('api/shop-prices', prices);
    },

    async create({ commit }, prices) {
      await axios.post('api/shop-prices', prices);
    },

    async delete({ commit }, id) {
      await axios.delete(`api/shop-prices/${id}`);
    },
  },
};
